import * as React from 'react';

const LightningIcon: React.FunctionComponent = () => {
  return (
    <svg
      width="60"
      height="66"
      viewBox="0 0 60 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33 1L1 39.4H29.8L26.6 65L58.6 26.6H29.8L33 1Z"
        stroke="white"
        strokeWidth="1.27778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LightningIcon;
